module.exports = __webpack_public_path__ + "img/twitter.1ca171b9.svg";